import { PreservedOrderTag } from '@/modules/order/constants/orderTag'
import { channelLabelStrToLabelList } from '@/modules/distribute/components/SetChannelTags/helpers'

/** 售后单信息 */
export interface AfterSaleOrderInfo {
    /** 退款单标签 */
    labels?: string[] | string
}

/** 检查给定售后单是否为特殊退款单 */
export function isSpecialRefundOrder(orderInfo: AfterSaleOrderInfo): boolean {
    const { labels } = orderInfo
    const labelList = Array.isArray(labels) ? labels : channelLabelStrToLabelList(labels)
    return labelList.includes(PreservedOrderTag.SPECIAL_REFUND_ORDER)
}

/** 检查给定售后单列表中是否存在特殊退款单 */
export function hasSpecialRefundOrder(orderList: AfterSaleOrderInfo[]): boolean {
    return orderList.some(isSpecialRefundOrder)
}
